import { useContext } from "react";
import { contextWeb3 } from "../contexts/ProviderWeb3";
import {  SHIPPING } from "../helpers";

export default function ShowTotal({ carrito }) {
  const { balanceStore } = useContext(contextWeb3);

  const total = carrito.reduce((acum, p) => {

    // checar si el producto tiene descuento.
    if(p.discount){
      // checar si tiene la cantidad de tokens para el descuento
        if(balanceStore >= p.minimum_amount_discount) {
          // aplicar descuento 120 10
          acum += (p.price * p.cantidad) - ((p.price * p.cantidad) * (p.discount))/100;
        }else{
          acum += p.cantidad * p.price;
        }
      }else{
        acum += p.cantidad * p.price;
      }
    return acum;

  }, 0);

  return <div >{`USD $${total+SHIPPING}`}</div>;
}
